import React from 'react';
import { pure, compose, withHandlers } from 'react-recompose';
// components
import { ActionsElement } from '../../../components/actions-element';
// features
import PC from '../../permission/role-permission';
// helpers/constants
import * as G from '../../../helpers';
// icons
import * as I from '../../../svgs';
//////////////////////////////////////////////////

const enhance = compose(
  withHandlers({
    handleEditInvoice: ({ edit, closeFixedPopup }) => () => {
      edit();
      closeFixedPopup();
    },
    handleRemoveInvoice: ({ data, remove, closeFixedPopup }) => () => {
      remove(data);
      closeFixedPopup();
    },
  }),
  pure,
);

const getOptions = (props) => ([
  {
    action: props.handleEditInvoice,
    text: G.getWindowLocale('actions:edit', 'Edit'),
    frontIcon: I.pencil(G.getTheme('colors.dark.blue')),
    permissions: G.ifElse(
      G.isTrue(props.completed),
      [PC.TEL_INVOICE_OVERWRITE_EXECUTE],
      [PC.TEL_FLEET_INVOICE_WRITE, PC.TEL_INVOICE_OVERWRITE_EXECUTE],
    ),
  },
  {
    action: props.handleRemoveInvoice,
    permissions: [PC.TEL_INVOICE_OVERWRITE_EXECUTE],
    frontIcon: I.trash(G.getTheme('colors.dark.blue')),
    text: G.getWindowLocale('actions:remove', 'Remove'),
  },
]);

export const InvoiceDetailsActions = (props) => <ActionsElement options={getOptions(props)} />;

export default enhance(InvoiceDetailsActions);
